const rangeInputs = document.querySelectorAll(".compare-products__range");

if (rangeInputs.length > 0) {
  rangeInputs.forEach((rangeInput) => {
    rangeInput.addEventListener("input", function () {
      const { value: position, parentElement } = this;
      const imageClipPath = 100 - position;

      const track = parentElement.querySelector(
        ".compare-products__range-track"
      );
      const afterElement = parentElement.querySelector(".after");

      requestAnimationFrame(() => {
        track.style.left = `${position}%`;
        afterElement.style.clipPath = `inset(0 ${imageClipPath}% 0 0)`;
      });
    });
  });
}
